/**
 * App entry point.
 *
 * Renders the React tree under React.StrictMode and wires the optional
 * Capacitor native bootstrap. `bootstrapNative()` is a no-op when the app
 * is running in a regular browser (Web/PWA) — it only does work when
 * packaged inside the iOS / Android native shell.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootstrapNative } from "@/lib/nativeBoot";

// Runs ONLY when packaged inside Capacitor (no-op in the browser).
bootstrapNative();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
